import { useEffect, useMemo } from 'react';
import { Switch, Route } from 'react-router-dom';

import { useAuth } from '@shared';
import { Badge } from '@components';
import { useAppContext } from '@molecules';
import Layout, { Menu, UserBar } from '../Layout';
import Routes, { getRoutes, useExternals } from '../Routes';

const AutoLoginRedirect = () => {
  const { loginWithRedirect } = useAuth();

  useEffect(() => {
    loginWithRedirect();
  }, [loginWithRedirect]);

  return null;
};

const renderTitle = (title?: React.ReactNode): React.ReactNode => {
  if (!title) return null;

  return (
    <header className="min-w-[12rem] basis-1/3 grow-0 shrink border-b border-active">
      <div className="font-medium text-title flex flex-row items-center justify-start gap-x-sm h-full">
        {typeof title === 'string' && <Badge text={title || ''} shrink />}
        <div
          className="truncate"
          title={typeof title === 'string' ? title : ''}
        >
          {title}
        </div>
      </div>
    </header>
  );
};

const Content = () => {
  const { loading, meta, title } = useAppContext();
  const auth = useAuth();
  const externals = useExternals(auth.organization_id);
  const routes = useMemo(() => getRoutes(meta), [meta]);
  const { isLoading, isAuthenticated, isAuthorized } = auth;

  if (loading || isLoading) return null;

  if (!isAuthenticated) return <AutoLoginRedirect />;

  if (!isAuthorized) return null;

  const userElement = <UserBar />;
  const titleElement = renderTitle(title);
  const menuElement = <Menu routes={routes} externals={externals} />;

  return (
    <Switch>
      <Route path="*">
        <Layout menu={menuElement} title={titleElement} user={userElement}>
          <Routes routes={routes} />
        </Layout>
      </Route>
    </Switch>
  );
};

export default Content;
